import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/simple-machines-calculator',
  component: () => import('../../routes/SimpleMachinesCalculator.svelte'),
  card: {
    id: 'simple-machines-calculator',
    title: 'Simple Machines Calculator',
    description: 'Calculate mechanical advantage, output force, and efficiency for levers and pulleys.',
    icon: 'precision_manufacturing',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/simple-machines-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Simple Machines Calculator – Levers & Pulleys Mechanical Advantage',
    description: 'Free simple machines calculator. Calculate ideal and actual mechanical advantage for class 1/2/3 levers, fixed/movable/compound pulleys. Shows output force, efficiency, and work ratios.',
  },
};

export default meta;